import React, { useMemo, useState } from "react";
import styles from "../Profile.module.scss";
import { useUser } from "../../../context/UserContext";
import { useLinkedAccounts } from "../../../context/LinkedAccountsContext";
import GameCarousel from "../../../components/GameCarousel/GameCarousel";
import { SteamAPI } from "../../../services/api/SteamApi";
import { Game, Profile } from "../../../types"
import { Section } from "../../../components/Section/Section";

// Import required modules
interface OverviewProps {
    profile: Profile
}

const Overview = ({ profile }: OverviewProps) => {
    const { user, linkedAccounts: accounts } = profile

    const [loading, setLoading] = useState<boolean>(true);
    const api = useMemo(() => new SteamAPI(), []);

    return (
        <>
            {/* Main Content */}
            <div className={styles.contentWrapper}>

                <main className={styles.mainColumn}>
                    {/* {featuredGames.length > 0 && <GameCarousel title={'Owned games'} games={featuredGames} loading={loading} />} */}
                    <Section>
                        <h3>Recent Activity</h3>
                        <ul className={styles.activityList}>
                            <li>Unlocked Platinum Vandal skin 🎨</li>
                            <li>5-star Animal Crossing island ⭐</li>
                            <li>Streaming Apex Legends ranked grind 🕹️</li>
                        </ul>
                    </Section>
                </main>

                <aside className={styles.sidebar}>
                    <Section>
                        <ul className={styles.activityList}>
                            <li><a href="">Achievements</a></li>
                            <li><a href="">Achievements</a></li>
                            <li><a href="">Achievements</a></li>
                            <li><a href="">Achievements</a></li>
                            <li><a href="">Achievements</a></li>
                            <li><a href="">Achievements</a></li>
                            <li><a href="">Achievements</a></li>
                            <li><a href="">Achievements</a></li>
                            <li><a href="">Achievements</a></li>
                        </ul>
                    </Section>
                </aside>

                {/* Main Column */}

            </div>
        </>
    );
};

export default Overview;
